module.exports = __webpack_public_path__ + "img/5.cdbc2d18.jpg";